import React from 'react'
import Contact from './Contact'

const About = () => {
  return (
    <div name="about" className="w-full h-screen bg-[#fffbf3]">
      <div className="flex flex-col justify-center items-center w-full h-full ">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="sm-text-right pb-8 px-8">
            <p className="text-4xl font-bold inline border-b-4 border-[#907aff]">
              About
            </p>
          </div>
          <div></div>
        </div>
        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-24 px-8">
          <div>
            <p>
              My name is Rebecca and I'm passionate about improving the lives of
              others through design. I'm constantly learning new things everyday
              and love meeting people who are motivated and unafraid of sharing
              their ideas with the world.
            </p>
          </div>
          <div>
            <p>
              I'm a self-taught designer and have learnt a lot of the processes,
              concepts and theories of UX/UI and product design through
              attending workshops, reading blogs and applying these to projects
              in my spare time and at work. I am very much a big-picture thinker
              and enjoy working on products end to end, for ideation all the way
              to development.
            </p>
          </div>
        </div>
      </div>
      {/* contact section */}
      <Contact />
    </div>
  )
}

export default About
